<template>
  <div class="animated fadeIn">
    <b-row class="mb-3">
      <b-col md="3" class="pt-2">{{ form.identifier }}</b-col>
      <b-col>
        <b-input-group append='"'>
          <b-form-input
            type="number"
            v-model="sample_soil.depth_start"
            placeholder="Start"
            :state="!$v.sample_soil.depth_start.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group append='"'>
          <b-form-input
            type="number"
            v-model="sample_soil.depth_end"
            placeholder="End"
            :state="!$v.sample_soil.depth_end.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group append='"'>
          <b-form-input
            type="number"
            :value="sample_soil.depth_total"
            placeholder="Total"
            disabled
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <add-on-select
      :selectedAddOns="add_ons"
      :addOns="filteredAddOns"
      @onAddOnSelect="onAddOnSelect"
    ></add-on-select>

    <b-form-group label="Analytes" :label-cols="3">
      {{ sampleAnalytes }}
    </b-form-group>
  </div>
</template>

<script>
import AddOnSelect from "../../AddOnSelect";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

const sample_soil = {
  depth_start: null,
  depth_end: null,
  depth_total: null
};

export default {
  name: "SoilSampleFormGroup",
  components: { AddOnSelect },
  mixins: [validationMixin, ToastNotifications],
  props: {
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    sample: {
      type: Object,
      default: () => null
    },
    index: {
      type: Number,
      default: null
    },
    testPackage: {
      type: Object,
      default: () => (null),
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      form: {
        test_package_sample_id: null,
        identifier: null
      },
      sample_soil: Object.assign({}, sample_soil),
      add_ons: []
    };
  },
  validations: {
    sample_soil: {
      depth_start: { required },
      depth_end: { required }
    }
  },
  computed: {
    test_package_samples () {
      return this.testPackage && this.testPackage.test_package_samples || []
    },
    sampleAnalytes () {
      let test_package_sample = this.test_package_samples && this.test_package_samples.find(item => item.id === this.sample.test_package_sample_id)
      let test_package_analytes = test_package_sample && test_package_sample.test_package_analytes

      return test_package_analytes ? test_package_analytes.map(({analyte}, index) => {
        return this.formatSampleAnalyte(analyte, index, test_package_analytes.length)
      }).join('') : ''
    },
    filteredAddOns() {
      let test_package_sample = this.test_package_samples && this.test_package_samples.find(item => item.id === this.sample.test_package_sample_id)
      let test_package_analytes = test_package_sample && test_package_sample.test_package_analytes
      let test_package_analytes_ids = new Set(test_package_analytes && test_package_analytes.map(({ analyte }) => analyte.id))

      return this.allTestPackages
        .filter((i) => i.cost_add_on)
        .filter((testPackage) => {
          return testPackage.test_package_samples.some(sample => {
            return sample.test_package_analytes.some(({ analyte }) => {
              return !test_package_analytes_ids.has(analyte.id)
            })
          })
        })
    }
  },
  methods: {
    updateTotal() {
      let start = this.sample_soil.depth_start || 0;
      let end = this.sample_soil.depth_end || 0;
      start = +start;
      end = +end;
      this.sample_soil.depth_total = end > start ? end - start : null;
    },
    onSampleChange() {
      let params = JSON.parse(JSON.stringify(this.form));
      params.sample_soil = this.sample_soil;
      params.add_ons = JSON.parse(JSON.stringify(this.add_ons));
      this.$emit("onSampleChange", {
        sample: params,
        index: this.index
      });
    },
    onAddOnSelect(addOns) {
      if (addOns && addOns.length) {
        this.add_ons = addOns;
      }
    },
    formatSampleAnalyte(analyte, index, count) {
      return `${analyte.abbrev}${index + 1 < count ? ", " : ""}`;
    }
  },
  watch: {
    form: {
      handler() {
        this.onSampleChange();
      },
      deep: true
    },
    sample_soil: {
      handler() {
        this.updateTotal();
        this.onSampleChange();
      },
      deep: true
    },
    add_ons: {
      handler() {
        this.onSampleChange();
      },
      deep: true
    }
  },
  created() {
    let sample = JSON.parse(JSON.stringify(this.sample));
    if (sample && sample.test_package_sample_id) {
      this.form.test_package_sample_id =
        typeof sample.test_package_sample_id != "undefined"
          ? sample.test_package_sample_id
          : null;
      this.form.identifier =
        typeof sample.identifier != "undefined" ? sample.identifier : null;
      if (sample.sample_soil) {
        this.sample_soil.depth_start =
          typeof sample.sample_soil.depth_start != "undefined"
            ? sample.sample_soil.depth_start
            : null;
        this.sample_soil.depth_end =
          typeof sample.sample_soil.depth_end != "undefined"
            ? sample.sample_soil.depth_end
            : null;
      }
      this.add_ons = typeof sample.add_ons != "undefined" ? sample.add_ons : [];
    }
  }
};
</script>
